// @flow

const LOCAL_STORAGE_KEY = "inquiryListParams";
const LOCAL_STORAGE_KEY_V2 = "inquiryListParamsV2";

type InquiryListParams = {
  page?: number,
  status?: string,
  currentLocation?: string,
  initialActiveIndex?: number,
  quickFilter?: ?string
};

export const getInquiryListParams = () => {
  const savedParamsRaw = localStorage.getItem(LOCAL_STORAGE_KEY);
  return JSON.parse(savedParamsRaw);
};

export const saveInquiryListParams = (newParams: InquiryListParams) => {
  const currentParams = getInquiryListParams();
  const mergedParams = {
    ...currentParams,
    ...newParams
  };

  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(mergedParams));
};

export const getInquiryListParamsV2 = () => {
  const savedParamsRaw = localStorage.getItem(LOCAL_STORAGE_KEY_V2);
  return JSON.parse(savedParamsRaw);
};

export const saveInquiryListParamsV2 = (newParams: InquiryListParams) => {
  const currentParams = getInquiryListParams();
  const mergedParams = {
    ...currentParams,
    ...newParams
  };

  localStorage.setItem(LOCAL_STORAGE_KEY_V2, JSON.stringify(mergedParams));
};

export const clearInquiryListParams = () => {
  localStorage.removeItem(LOCAL_STORAGE_KEY);
  localStorage.removeItem(LOCAL_STORAGE_KEY_V2);
};
